import { Container, SectionTitle, Timeline } from '@sloyd/ui';
import { Json } from '../../types';
import { Wrapper } from './ContentWhatsNew.style';

export type ContentWhatsNewProps = {
  items: Json[];
};

export function ContentWhatsNew(props: ContentWhatsNewProps) {
  const { items } = props;

  return (
    <Wrapper className='ContentWhatsNew-wrapper' data-testid='ContentWhatsNew-wrapper'>
      <SectionTitle gradient={{ from: '#00c6ff', to: '#0072ff' }} title='🚀 Roadmap'>
        See the latest features and planned capabilities.
      </SectionTitle>
      <Container>
        <Timeline items={items} />
      </Container>
    </Wrapper>
  );
}

export default ContentWhatsNew;
